/**
 * Contact Service
 * Handles contact form submissions
 */

const API_URL = 'https://nmdiamond.in/api/contact/submit.php';

/**
 * Submit contact form
 * @param {Object} formData - Form data to submit
 * @returns {Promise<Object>} Response from the API
 */
export const submitContactForm = async (formData) => {
    try {
        console.log('Submitting form data:', formData);

        const response = await fetch(API_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            mode: 'cors',
            body: JSON.stringify({
                name: formData.name,
                email: formData.email,
                phone: formData.phone || '',
                subject: formData.subject,
                message: formData.message
            })
        });

        // Log the raw response
        const responseText = await response.text();
        console.log('Raw response:', responseText);

        // Try to parse the response as JSON
        let data;
        try {
            data = JSON.parse(responseText);
        } catch (e) {
            console.error('Failed to parse response as JSON:', e);
            throw new Error('Invalid response from server: ' + responseText);
        }

        // Check if the response was not ok
        if (!response.ok) {
            throw new Error(data.error || `Server error: ${response.status}`);
        }

        return data;
    } catch (error) {
        console.error('Error submitting contact form:', error);
        throw error;
    }
};

export default {
    submitContactForm
}; 